import ThreeColumnsSection from "./ThreeColumnsSection";

export default ThreeColumnsSection;
